// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"e919003f","947":"be77114e"}[chunkId] + ".chunk.css";
};